import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

// Pages
import Dashboard from './pages/Dashboard';
import DesktopSetup from './pages/DesktopSetup';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProjectList from './pages/ProjectList';
import ProjectDetail from './pages/ProjectDetail';
import ProfilePage from './pages/ProfilePage';
import MyTasksPage from './pages/MyTasksPage';
import Meetings from './pages/Meetings';
import SettingsPage from './pages/SettingsPage';
import JoinProject from './pages/JoinProject';
import AcceptInvite from './pages/AcceptInvite';
import SubscriptionPage from './pages/SubscriptionPage';
import AdminPage from './pages/AdminPage';
import HelpDeskPage from './pages/HelpDeskPage';
import AnalyticsPage from './pages/AnalyticsPage';
import NotificationPreferencesPage from './pages/NotificationPreferencesPage';
import CalendarPage from './pages/CalendarPage';
import DocumentationPage from './pages/DocumentationPage';
import PortfolioPage from './pages/PortfolioPage';
import ReportPage from './pages/ReportPage';
import DeveloperPage from './pages/DeveloperPage';

// Composants
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

const isElectron = typeof window !== 'undefined' && window.electronAPI?.isElectron === true;

function App() {
  // En mode desktop, si le nom n'est pas encore défini → setup
  const desktopReady = !isElectron || !!localStorage.getItem('era_desktop_user');

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', display: 'flex', flexDirection: 'column' }}>
      <Routes>
        {/* Route de setup desktop (premier lancement) */}
        {isElectron && <Route path="/setup" element={<DesktopSetup />} />}

        {/* Redirection de la racine vers le dashboard ou login */}
        <Route
          path="/"
          element={
            isElectron
              ? (desktopReady ? <Navigate to="/dashboard" replace /> : <Navigate to="/setup" replace />)
              : (localStorage.getItem('era_token') ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />)
          }
        />

        {/* Routes publiques (non-desktop uniquement) */}
        {!isElectron && <Route path="/login" element={<Login />} />}
        {!isElectron && <Route path="/register" element={<Register />} />}
        {!isElectron && <Route path="/verify-email" element={<VerifyEmail />} />}
        {!isElectron && <Route path="/forgot-password" element={<ForgotPassword />} />}
        {!isElectron && <Route path="/reset-password/:token" element={<ResetPassword />} />}

        {/* Routes privées avec Layout */}
        <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/my-cards" element={<MyTasksPage />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/settings" element={<SettingsPage />} />
            {!isElectron && <Route path="/subscription" element={<SubscriptionPage />} />}
            {!isElectron && <Route path="/join/:token" element={<JoinProject />} />}
            {!isElectron && <Route path="/invite/:token" element={<AcceptInvite />} />}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/helpdesk" element={<HelpDeskPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/notifications/preferences" element={<NotificationPreferencesPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/documentation" element={<DocumentationPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/reports" element={<ReportPage />} />
            <Route path="/developers" element={<DeveloperPage />} />
        </Route>

        {/* Route 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
